export default __webpack_public_path__ + "static/media/eu-flag.63b0e517.svg";